import React, { useEffect, useState } from "react";
import { BlueTickIcon, DashboardOnboardingIcon, DashboardRocketIcon, DownArrow, DownArrowIcon, ToasterCancelIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";
import * as selector from "../../selectors/selectors"
import { useSelector } from "react-redux";


interface Iprops {
    Classname: string;
    CheckPoints: {
        Title: string,
        Status: boolean,
    }[];
    HideBubble?: boolean;
    Close: () => void;
}

const OnboardingCheckPoints: React.FC<Iprops> = (props: Iprops) => {

    const IsMobileDevice = useSelector(selector.isMobileDevice)

    const navigate = useNavigate()

    const [progress, setProgress] = useState<number>(0);
    const [step, setStep] = useState<number>(0);

    useEffect(() => {
        let Prgs = Math.round((props.CheckPoints.filter(x => x.Status).length / props.CheckPoints?.length) * 100)
        setProgress(Prgs)
    }, [props.CheckPoints])

    const handleSkipPoints = () => {
        if (props.CheckPoints.filter(y => !y.Status).length === (step + 1)) {
            setStep(0)
        }
        else {
            setStep(step + 1)
        }
    }


    const handleOnclick = (title) => {
        if (title === "Fill in your profile details") {
            navigate(AppRoutes.PROFILE, { state: true })
        }
        if (title === "Add your 1st channel") {
            navigate(AppRoutes.ADD_CHANNELS)
        }
        if (title === "Create and save new template") {
            navigate(AppRoutes.TEMPLATES)
        }
    }

    const handleClose = () => {
        props.Close();
    }

    return (
        <div className={`falkon-chat-dashboard-banner h-p-100 flex-1 d-flex flex-direction br-4 p-relative ${props.Classname}`}>
            {props.HideBubble ? <DownArrow className="p-absolute t-5 r-3 c-pointer" onClick={handleClose}/> : <ToasterCancelIcon className="p-absolute t-5 r-3 c-pointer" onClick={handleClose} />}
            <div className={`w-p-100 ${IsMobileDevice ? "h3-medium" : "h2-medium"} px-4 pt-4`}>Hey! Let's begin Onboarding</div>
            <div className='w-p-100 pl-3 d-flex align-center color-channel-dashboard-average-response-time-header h5-medium pt-2'>
                <DashboardRocketIcon className='mr-1' />
                <div className='w-p-60 h-2 bg-color-secondary br-4 d-flex align-center dashboard-profile-progress mr-2'>
                    <div className={`h-p-100 bg-color-channel-dashboard-total-tickets-header  br-4 d-flex align-center justify-flex-end color-secondary h5-regular w-p-${progress}`} >
                    </div>
                </div>
                {progress} %
            </div>
            {props.CheckPoints.filter(y => y.Status)?.map(x => {
                return (
                    <div className='pl-4 d-flex align-center color-channel-dashboard-average-response-time-header h5-medium pt-2'>
                        {x.Status ?
                            <BlueTickIcon className='mr-1' width={21} height={20} />
                            :
                            <div className='w-2 h-2 br-p-50 mr-1 d-flex justify-center align-center onboarding-checkpoints-count-border'>

                            </div>
                        }
                        <span className={`${x.Status && "color-onboarding-checkpoints-done"}`}>{x.Title}</span>
                    </div>
                )
            })}
            {props.CheckPoints.filter(y => !y.Status)?.map((x, index) => {
                return (
                    <div className='pl-4 d-flex align-center color-channel-dashboard-average-response-time-header h5-medium pt-2 c-pointer f-link-hover' onClick={() => handleOnclick(x.Title)}>
                        <div className={`w-2 h-2 br-p-50 mr-1 d-flex justify-center align-center ${step === index ? "onboarding-checkpoints-count-border-active" : "onboarding-checkpoints-count-border"} `}>

                        </div>
                        <span className={`${step === index && "color-primary-light"}`}>{x.Title}</span>
                    </div>
                )
            })}
            <div className='w-p-100 pl-4 d-flex align-center mt-auto'>
                {progress !== 100 && !!props.CheckPoints.length &&
                    <div className="mr-4 t-decoration-underline color-channel-dashboard-average-response-time-header h5-medium f-link-hover c-pointer" onClick={handleSkipPoints}>
                        Skip step
                    </div>
                }
                {progress !== 100 && !!props.CheckPoints.length &&
                    <ButtonComponent ButtonLabel='Next' Variant={'primary-btn'} ClassName='w-10 mr-auto' OnClick={() => handleOnclick(props.CheckPoints.filter(x => !x.Status)[step].Title)} />
                }
                {!props.HideBubble && <DashboardOnboardingIcon className="ml-auto mr-4" />}
            </div>
        </div >
    )
}

export default OnboardingCheckPoints;